export default "__VITE_ASSET__BSOLCyDL__"